/** GxBriefSheet (screens §P4.2): the round brief, dismissible per round and user to a "Round brief" chip (local storage). */
import { useState, type ReactNode } from "react";

export interface BriefItem { readonly key: string; readonly title: string; readonly body: ReactNode }

function readDismissed(key: string): boolean {
  try { return localStorage.getItem(key) === "1"; } catch { return false; }
}

function writeDismissed(key: string, dismissed: boolean): void {
  try { if (dismissed) localStorage.setItem(key, "1"); else localStorage.removeItem(key); } catch { /* storage can be blocked; the choice then lasts for this visit only */ }
}

export function GxBriefSheet({ storageKey, fyLabel, items, onFullBrief }: {
  readonly storageKey: string; readonly fyLabel: string; readonly items: readonly BriefItem[]; readonly onFullBrief: () => void;
}) {
  const [dismissed, setDismissed] = useState(() => readDismissed(storageKey));
  const set = (value: boolean) => { setDismissed(value); writeDismissed(storageKey, value); };
  if (dismissed) {
    return <button type="button" className="gx-chip gx-brief-chip" data-testid="cockpit.brief.chip" onClick={() => set(false)}>Round brief · {fyLabel}</button>;
  }
  return (
    <section className="gx-card gx-brief" data-testid="cockpit.brief">
      <div className="gx-brief-lab"><span>Round brief</span><b>{fyLabel}</b></div>
      {items.map((it) => (
        <div key={it.key} className="gx-brief-it"><span className="gx-brief-k">{it.title}</span><span>{it.body}</span></div>
      ))}
      <div className="gx-brief-acts">
        <button type="button" className="gx-btn gx-btn--ghost" onClick={onFullBrief}>Full brief <span aria-hidden="true">›</span></button>
        <button type="button" className="gx-x gx-brief-x" aria-label="Dismiss brief" onClick={() => set(true)}><span aria-hidden="true" className="gx-brief-x-glyph">×</span><span aria-hidden="true" className="gx-brief-x-word">Hide</span></button>
      </div>
    </section>
  );
}
